import { takeLatest, put } from 'redux-saga/effects';
import { SAVE_DRAFT_MESSAGE, RESTORE_DRAFT_MESSAGE } from '../constants/chat';
import { CHAT_SEND_MESSAGE, CHAT_UPDATE_MESSAGE } from '../../chat/modules/new-message';
import chatStorage from '../utils/storage/chat';
import { SET_ACTIVE_CHAT } from '../../chat/modules/chat-actions';

function* saveDraftMessageFlow({ payload: { id, text } }) {
  chatStorage.draft.set(id, text);
}

function* removeDraftMessageFlow({ payload: { chatId: id } }) {
  chatStorage.draft.remove(id);
}

function* setActiveChatFlow({
  payload: {
    chat: { id },
  },
}) {
  const text = chatStorage.draft.get(id);
  yield put({
    type: CHAT_UPDATE_MESSAGE,
    payload: { text },
  });
}

export function* chatFlow() {
  yield takeLatest(SAVE_DRAFT_MESSAGE, saveDraftMessageFlow);
  yield takeLatest(CHAT_SEND_MESSAGE, removeDraftMessageFlow);
  yield takeLatest(SET_ACTIVE_CHAT, setActiveChatFlow);
}

export default chatFlow;



// WEBPACK FOOTER //
// ./app/javascript/common/sagas/chat.js